export default __webpack_public_path__ + "static/media/login_logo.fb3d82f2.JPG";